import { dataLayerPush } from 'src/helpers/gtm';

/**
 * Отсылается при открытие recaptcha
 */
export const pushOpenReCaptchaAnalytics = () => {
  dataLayerPush({ event: 'open_recaptcha' });
};

/**
 * Отсылается при провальном прохождении
 */
export const pushFailedReCaptchaAnalytics = () => {
  dataLayerPush({ event: 'fail_recaptcha' });
};
/**
 * Отсылается при удачном прохождении капчи
 */
export const pushSuccessReCaptchaAnalytics = () => {
  dataLayerPush({ event: 'success_recaptcha' });
};
